import React from 'react'
import HelloSign from 'hellosign-embedded'
import styled from 'styled-components'
import Image from './../common/Image'
import CanceledImage from './../../images/canceled.svg'
import SignedImage from './../../images/signed.svg'

const Container = styled.div`
  width: 100%;
  background: white;
`
const Body = styled.div`
  margin-top: 35px;
  padding: 20px;
  display: flex;
  font-size: 16px;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`

const HeaderText = styled.h2`
  margin-top: 30px;
  text-align: center;
`

const BodyText = styled.p`
  margin-top: 10px;
  text-align: center;
`

class SignatureRequest extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      errorText: null,
      errorHeader: null
    }
  }

  componentDidMount ()  {
    const { url, clientId, testMode, errorType } = this.props

    if (url) {
      const client = new HelloSign()

      client.on(HelloSign.events.SIGN, () => {
        this.setState({
          image: SignedImage,
          errorHeader: "Document Successfully E-Signed",
          errorText: "Your document was successfully signed. No further action is required."
        })
      })

      client.open(url, {
        clientId: clientId,
        skipDomainVerification: testMode
      })
    } else {
      if(errorType === 'canceled'){
        this.setState({
          image: CanceledImage,
          errorHeader: "E-Sign Request Canceled",
          errorText: "This request has been canceled. Please contact us if you have any questions."
        })
      }else if(errorType === 'signed'){
        this.setState({
          image: SignedImage,
          errorHeader: "Document Already E-Signed",
          errorText: " Your document has already been signed. No further action is required."
        })
      }
    }
  }

  render() {
    return (
      <Container>
        <Body>
          <Image src={ this.state.image } title="Icon"/>

          <HeaderText dangerouslySetInnerHTML={{ __html: this.state.errorHeader }}></HeaderText>
          <BodyText dangerouslySetInnerHTML={{ __html: this.state.errorText }}></BodyText>
        </Body>
      </Container>
    )
  }
}

export default SignatureRequest
